import * as React from "react"
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group"
import { cn } from "@/lib/utils"

interface CustomRadioGroupProps extends React.ComponentProps<typeof RadioGroup> {
  orientation?: "vertical" | "horizontal"
}

export function CustomRadioGroup({
  className,
  orientation = "vertical",
  ...props
}: CustomRadioGroupProps) {
  return (
    <RadioGroup
      className={cn(
        // base styles
        "w-full",

        // handle orientation
        orientation === "vertical" && "flex flex-col gap-2",
        orientation === "horizontal" && "flex flex-row gap-6",

        className
      )}
      {...props}
    />
  )
}

export { RadioGroupItem }
